
import cascader from "../../library/cascader.vue"
import commonConfig from "@/utils/common.js"
import { trackWellcomeClickEvent } from "@/utils/track"

export default {
  name: "WelcomeBg",
  components: {
    cascader
  },
  data() {
    return {
      categoryShow: false,
      shortenHeader: false,
      wellcomeListShow: false,
      wellcomeList: [
        {
          name: "ourStory",
          url_zh_HK: "/zh-hant/about-wellcome",
          url_en_US: "/en/about-wellcome"
        },
        {
          name: "corporateResponsibility",
          url_zh_HK: "/zh-hant/green-initiatives-list",
          url_en_US: "/en/green-initiatives-list"
        },
        {
          name: "corporatePromotions",
          url_zh_HK: "/zh-hant/yuu-rewards-club",
          url_en_US: "/en/yuu-rewards-club"
        },
        {
          name: "contactUs",
          url_zh_HK: "/zh-hant/contact-us/our-contact",
          url_en_US: "/en/contact-us/our-contact"
        },
        {
          name: "careers",
          url_zh_HK: "/zh-hant/join-us",
          url_en_US: "/en/join-us"
        },
        {
          name: "termsAndConditions",
          url_zh_HK: "/zh-hant/terms-of-use",
          url_en_US: "/en/terms-of-use"
        },
        {
          name: "wellcomeWhatsAppTermsAndConditions",
          url_zh_HK: "/zh-hant/wellcome-whatsapp-terms-and-conditions",
          url_en_US: "/en/wellcome-whatsapp-terms-and-conditions"
        }
      ]
    }
  },

  computed: {
    style() {
      if (this.categoryShow) {
        if (this.shortenHeader) {
          return { borderRadius: ".12rem .12rem 0 0" }
        } else {
          return { borderRadius: ".12rem .12rem .12rem 0" }
        }
      } else if (this.shortenHeader) {
        return { borderRadius: ".12rem .12rem 0 0" }
      } else {
        return { borderRadius: ".12rem" }
      }
    },
    wellcomeLink() {
      const lang = this.$i18n.locale
      const openUrl = lang == "en_US" ? "/en/about-wellcome" : "/zh-hant/about-wellcome"
      return openUrl
    }
  },
  created() {},
  mounted() {
    this.$bus.$off("setShortenHeader")
    this.$bus.$on("setShortenHeader", this.setShortenHeader)
  },
  beforeDestroy() {
    this.$bus.$off("setShortenHeader")
  },
  methods: {
    setShortenHeader(value = false) {
      this.shortenHeader = value
    },
    handleCategoryClick() {
      this.categoryShow = !this.categoryShow
    },
    hideCategory() {
      this.categoryShow = false
    },
    handleWellcomeHover() {
      this.wellcomeListShow = true
    },
    handleWellcomeOut() {
      this.wellcomeListShow = false
    },
    goItem(item) {
      const lang = this.$i18n.locale
      const url = item[`url_${lang}`]
      if (url) {
        window.open(url)
      }
      this.handleWellcomeOut()
    },
    goItemLink(item) {
      const lang = this.$i18n.locale
      const url = item[`url_${lang}`]
      return url
    },
    trackWellcomeClickEvent,
    handleFollow(type) {
      switch (type) {
        case "facebook":
          return this.$t("common.facebookLink")
        case "ins":
          return this.$t("common.instagramLink")
        case "youtube":
          return this.$t("common.youtubeLink")
        default:
          break
      }
    }
  }
}
